var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-content wish_bets_pages" }, [
    _vm.wishBetAuthorizationToken
      ? _c("div", [
          !_vm.savedBetsLoaded || _vm.deleteBetInProgress
            ? _c("div", [_c("dots-loader")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.savedBetsLoaded && !_vm.deleteBetInProgress
            ? _c("div", [
                !_vm.showPageTitleInHeader ||
                (_vm.showPageTitleInHeader && _vm.tabletAndAbove)
                  ? _c("h1", [_vm._v(_vm._s(_vm.$t("PageTitle.savedbets")))])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.wishBetStoredBets.length
                  ? _c("div", { staticClass: "wishBetStoredBets" }, [
                      _c("h3", { staticClass: "no_saved_bets" }, [
                        _vm._v(_vm._s(_vm.$t("WishBets.SavedBets")))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.wishBetStoredBets.length > 0
                  ? _c(
                      "div",
                      { staticClass: "wishBetStoredBets" },
                      _vm._l(_vm.wishBetStoredBets, function(wishBet, index) {
                        return _c(
                          "div",
                          {
                            attrs: {
                              set: [
                                (_vm.isBetSGPV = _vm.isBetSGP(wishBet)),
                                (_vm.isBetSGPPlusV = _vm.isBetSGPPlus(wishBet))
                              ]
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "saved_bet" },
                              [
                                _c("div", { staticClass: "saved_bet_header" }, [
                                  !_vm.isBetSGPV && !_vm.isBetSGPPlusV
                                    ? _c(
                                        "span",
                                        { staticClass: "bet_type_name" },
                                        [
                                          wishBet.BetTypeExt
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(wishBet.BetTypeExt)
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(wishBet.betTypeName)
                                                )
                                              ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isBetSGPV
                                    ? _c(
                                        "span",
                                        { staticClass: "bet_type_name" },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "BetSlip.tab.title.SGP." +
                                                    _vm.isBetSGPV,
                                                  {
                                                    legs: wishBet.betLegs.length
                                                  }
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isBetSGPPlusV
                                    ? _c(
                                        "span",
                                        { staticClass: "bet_type_name" },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "BetSlip.tab.title.SGP.Plus",
                                                  {
                                                    legs: wishBet.betLegs.length
                                                  }
                                                )
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "SgpPlusParticipants"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.sgpPlusParticipants(
                                                      wishBet
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "delete_bet",
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteWishBet(wishBet)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(wishBet.betLegs, function(
                                  leg,
                                  legIndex
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "saved_bet_leg" },
                                    [
                                      leg.idfosporttype
                                        ? _c(
                                            "div",
                                            { staticClass: "betsporticon" },
                                            [
                                              _c("icon", {
                                                attrs: {
                                                  name:
                                                    "icon-" +
                                                    (leg.idfosporttype
                                                      .split(" ")
                                                      .join("")
                                                      .toLowerCase() || "empty")
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "leg_details" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "leg_eventname" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(leg.eventName) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "leg_selectionName"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(leg.selectionName) +
                                                  "\n                  "
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formattedHcp")(leg)
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "leg_marketname" },
                                            [_vm._v(_vm._s(leg.marketName))]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "leg_info_right" },
                                        [
                                          leg.PriceUp &&
                                          leg.PriceDown &&
                                          !_vm.sgpPriceTypes.includes(
                                            leg.IDFOPriceType &&
                                              (leg.IDFOPriceType.toUpperCase() ||
                                                "")
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "leg_price" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatLegOdds")(
                                                          leg
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.liveEvents.filter(function(ev) {
                                            return (
                                              ev.idfoevent === leg.IDFOEvent
                                            )
                                          }).length > 0
                                            ? _c(
                                                "div",
                                                { staticClass: "legliveicon" },
                                                [_vm._v(" LIVE")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "saved_bet_results" },
                                  [
                                    _c("div", { staticClass: "betodds" }, [
                                      _c("span", { staticClass: "hint" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("WishBet.OddsPrice"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      wishBet.totalPrice &&
                                      wishBet.totalPrice !== 0
                                        ? _c("div", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatOdds")(wishBet)
                                              )
                                            )
                                          ])
                                        : _c("div", { staticClass: "value" }, [
                                            _vm._v("-")
                                          ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "betstake" }, [
                                      _c("span", { staticClass: "hint" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("WishBet.BetAmount"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "value" }, [
                                        wishBet.totalStake
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    wishBet.totalStake
                                                  )
                                                )
                                              )
                                            ])
                                          : _c("span", [_vm._v("-")])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "betreturn" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("WishBet.MaxWin")))
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "value" }, [
                                        wishBet.winStake * wishBet.totalPrice -
                                        wishBet.totalStake
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      wishBet.winStake *
                                                        wishBet.totalPrice -
                                                        wishBet.totalStake
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _c("span", [_vm._v("-")])
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "saved_bet_actions" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "generate_qrcode",
                                        on: {
                                          click: function($event) {
                                            return _vm.generateBarCode(
                                              wishBet.placementToken
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("WishBet.GenerateBarcode")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-675dbb70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675dbb70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/WishBet/SavedBetsPage.vue
// module id = null
// module chunks = 